import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="py-24 px-6 bg-[#2B2D2F]">
      <div className="max-w-[1280px] mx-auto text-center">
        <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-4">
          Take the First Step
        </span>
        <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white mb-6">
          Your Wealth-Building Journey Starts Here
        </h2>
        <p className="text-white/60 text-lg max-w-2xl mx-auto mb-10 font-['Inter'] font-light leading-relaxed">
          Whether you are ready to enroll in our Trading Academy, explore advisory services, build a strategic partnership, or simply learn more — we are here to guide you with clarity and purpose.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center flex-wrap">
          <Link
            to="/trading-academy"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md bg-[#C9A961] text-[#2B2D2F] font-semibold text-sm hover:bg-[#b8943f] transition-colors whitespace-nowrap cursor-pointer"
          >
            Apply for the Trading Academy <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/advisory"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md border border-white/30 text-white font-medium text-sm hover:border-[#C9A961] hover:text-[#C9A961] transition-colors whitespace-nowrap cursor-pointer"
          >
            Book a Consultation
          </Link>
          <Link
            to="/partnerships"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md border border-[#C9A961]/50 text-[#C9A961] font-medium text-sm hover:bg-[#C9A961]/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shake-hands-line" /> Explore Partnerships
          </Link>
        </div>
      </div>
    </section>
  );
}
